import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { DividerGroupStyled, DividerStyled, StyledTypography } from './styles';

/**
 * DividerGroup Component
 *
 * This component renders a group of dividers and a text element to display the word "or".
 */
const DividerGroup: FC = () => {
  const { t } = useTranslation();

  return (
    <DividerGroupStyled>
      <DividerStyled />

      <StyledTypography>{t('or')}</StyledTypography>

      <DividerStyled />
    </DividerGroupStyled>
  );
};

export default DividerGroup;
